import {AbstractControl, ValidationErrors} from '@angular/forms';

/**
 * Contrôle du format du numéro de téléphone
 */
export function NumeroTelephoneValidator(control: AbstractControl): ValidationErrors | null {
    const numeroTelephone = control.value;

    // Verifie que le numéro ne comporte que des chiffres
    const regex = /^\d+$/;

    if (numeroTelephone && !regex.test(numeroTelephone)) {
        return { erreurCaractere: true };
    }
    return null;
}
